export default __webpack_public_path__ + "static/media/tennis-firstServe-cover.ba858f4e.png";